import {notifyBugsnag} from "../../../errors/bugsnag/notify_bugsnag";
import {addNotification} from "../../../notifications/state/notifications_slice";
import {useAppSelector} from "../../../store/hooks";
import {hideOfferModal} from "../../state/offer_modals_slice";
import {IOfferModalName} from "../../types/OfferModalName";
import {IOfferModalOffer} from "../../types/OfferModalOffer";

type Params = {
    offers: IOfferModalOffer[];
    page: number;
    pageSize: number;
    modalName: IOfferModalName;
};

export const useOfferModalOfferWithPosition = (params: Params) => {
    const {offers, page, pageSize, modalName} = params;

    const offerId = useAppSelector((state) => state.offerModals[modalName].offerId);
    const offer = useAppSelector((state) => state.offerModals[modalName].offer);
    const offersStartingPosition = page > 1 ? (page - 1) * pageSize : 0;
    const offersWithPosition = offers.map((offer, index) => ({id: offer.id, position: offersStartingPosition + index, data: offer}));

    const currentOfferPosition = offersWithPosition.findIndex((offer) => offer.id === offerId) + offersStartingPosition;
    const selectedOffer = offer ? {id: offer.id, position: currentOfferPosition, data: offer} : offersWithPosition.find((offer) => offer.id === offerId);

    if (!selectedOffer) {
        notifyBugsnag(
            {
                message: `Offer ${offerId} is not available in query`,
                groupingHash: "offer-not-available-in-query"
            },
            `Offer ${offerId} is not available in query`,
            {offer, offersList: offers}
        );

        addNotification({
            notification: {
                content: `Przepraszamy, wystąpił błąd podczas ładowania szczegółów oferty.`,
                type: "failure"
            }
        });

        hideOfferModal({modalName});
    }

    return {
        selectedOffer,
        offerId,
        offer,
        offersWithPosition,
        offersStartingPosition
    };
};
import {notifyBugsnag} from "../../../errors/bugsnag/notify_bugsnag";
import {addNotification} from "../../../notifications/state/notifications_slice";
import {useAppSelector} from "../../../store/hooks";
import {hideOfferModal} from "../../state/offer_modals_slice";
import {IOfferModalName} from "../../types/OfferModalName";
import {IOfferModalOffer} from "../../types/OfferModalOffer";

type Params = {
    offers: IOfferModalOffer[];
    page: number;
    pageSize: number;
    modalName: IOfferModalName;
};

export const useOfferModalOfferWithPosition = (params: Params) => {
    const {offers, page, pageSize, modalName} = params;

    const offerId = useAppSelector((state) => state.offerModals[modalName].offerId);
    const offer = useAppSelector((state) => state.offerModals[modalName].offer);
    const offersStartingPosition = page > 1 ? (page - 1) * pageSize : 0;
    const offersWithPosition = offers.map((offer, index) => ({id: offer.id, position: offersStartingPosition + index, data: offer}));

    const currentOfferPosition = offersWithPosition.findIndex((offer) => offer.id === offerId) + offersStartingPosition;
    const selectedOffer = offer ? {id: offer.id, position: currentOfferPosition, data: offer} : offersWithPosition.find((offer) => offer.id === offerId);

    if (!selectedOffer) {
        notifyBugsnag(
            {
                message: `Offer ${offerId} is not available in query`,
                groupingHash: "offer-not-available-in-query"
            },
            `Offer ${offerId} is not available in query`,
            {offer, offersList: offers}
        );

        addNotification({
            notification: {
                content: `Przepraszamy, wystąpił błąd podczas ładowania szczegółów oferty.`,
                type: "failure"
            }
        });

        hideOfferModal({modalName});
    }

    return {
        selectedOffer,
        offerId,
        offer,
        offersWithPosition,
        offersStartingPosition
    };
};
